export default class Mutations
{
	public static resetProjectToDefault = 'resetProjectToDefault';
	public static timelineSyncNodesPostProcess = 'timelineSyncNodesPostProcess';
    public static setNode = 'setNode';
    public static setTag = 'setTag';
    public static updateNodeTitle = 'updateNodeTitle';
    public static updateNodeImportant = 'updateNodeImportant';
    public static updateNodeDescription = 'updateNodeDescription';
    public static updateNodeReferences = 'updateNodeReferences';
    public static updateNodeStart = 'updateNodeStart';
    public static updateNodeEnd = 'updateNodeEnd';
    public static updateNodeDateOptions = 'updateNodeDateOptions';
    public static updateNodeImage = 'updateNodeImage';
    public static updateNodeVideo = 'updateNodeVideo';
    public static updateNodeImageCaption = 'updateNodeImageCaption';
    public static updateNodeAudio = 'updateNodeAudio';
    public static setConnection = 'setConnection';
    public static removeConnection = 'removeConnection';
    public static updateConnectionText = 'updateConnectionText';
    public static updateConnectionDirection = 'updateConnectionDirection';
    public static addNodeTag = 'addNodeTag';
    public static removeNodeTag = 'removeNodeTag';
    public static addTimelineTag = 'addTimelineTag';
    public static removeTimelineTag = 'removeTimelineTag';
    public static deleteNode = 'deleteNode';
    public static deleteTag = 'deleteTag';
    public static updateTimelineTitle = 'updateTimelineTitle';
    public static updateTimelineDescription = 'updateTimelineDescription';
    public static updateTimelineComments = 'updateTimelineComments';
    public static setTimeline = 'setTimeline';
    public static setMapToTimeline = 'setMapToTimeline';
    public static deleteTimeline = 'deleteTimeline';
    public static addTimelineNode = 'addTimelineNode';
    public static removeTimelineNode = 'removeTimelineNode';
    public static fullSyncTimelinesInit = 'fullSyncTimelinesInit';
    public static fullSyncMapNodesInit = 'fullSyncMapNodesInit';
    public static updateMapData = 'updateMapData';
    public static setMapNode = 'setMapNode';
    public static destroyMapNode = 'destroyMapNode';
    public static setTimelineAccess = 'setTimelineAccess';
    public static setTimelineAccessList = 'setTimelineAccessList';
    public static setTimelineEventOrdering = 'setTimelineEventOrdering';
    public static setProject = 'setProject';
    public static setActiveTimeline = 'setActiveTimeline';
    public static setSelected = 'setSelected';
    public static chatMessage = 'chatMessage';
    public static deleteChatMessage = 'deleteChatMessage';
    public static setLocalUserData = 'setLocalUserData';
    public static setPresentationMode = 'setPresentationMode';
    public static setPresentationFullSlide = 'setPresentationFullSlide';
    public static setTimelineFormMode = 'setTimelineFormMode';
    public static updateProjectMetadata = 'updateProjectMetadata';
    public static updateTagTitle = 'updateTagTitle';
    public static updateTagColor = 'updateTagColor';
    public static updateNodeColor = 'updateNodeColor';
    public static flagCopyingTimeline = 'flagCopyingTimeline';
    public static clearCopyingTimeline = 'clearCopyingTimeline';
    public static setFolder = 'setFolder';
    public static deleteFolder = 'deleteFolder';
    public static setTimelineFolder = 'setTimelineFolder';
    public static setFolderAccess = 'setFolderAccess';
    public static timelineSyncTimelineTags = 'timelineSyncTimelineTags';
    public static setAccessedTimelines = 'setAccessedTimelines';
    public static setTimelineSyncing = 'setTimelineSyncing';
    public static notifyTagFilterUpdated = 'notifyTagFilterUpdated';
}